import React, { useState, useRef } from "react";
import { instance } from "../../axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { setStorage } from "../../helper";
import { useStore } from "../../state.js";
import { useNavigate, Link } from "react-router-dom";
import { UiButton, UiInput, OverlayLoader } from '../../ui'
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

const ForgotPassword = ({ ...props }) => {
  const { auth, setAuth } = useStore((state) => state);
  let navigat = useNavigate();

  const schema = yup.object().shape({
    otpgen:yup.bool(),
    username: yup.string().required("Username is required"),
    otp: yup.string().nullable().when('otpgen', {
      is:  true,
      then: (rule) => rule
        .required("Enter OTP")

    }),

    password: yup.string().when('otpgen', {
      is: true,
      then: yup.string().required("Please enter password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        )
    }),
    password1: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        "The password and its confirm are not the same"
      ),
  });
  const [state, setState] = useState({});
  const [optGen, setOtpGen] = useState(false);
  var doLogin = (e) => {
    setState({ loader: true });
    var form = document.querySelector("form");
    var data = new FormData(form);

    instance({
      method: "post",
      url: "/forgot_password",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setState({ loader: false });
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        } else {
          toast(response.data.msg, { type: "success" });
        if (response.data.password_changed == true) {
          navigat("/login", { replace: true });
        } else {
          reset(response.data)
          setOtpGen(true);
        }
      }
      })
      .catch(function (response) { });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    doLogin();
    //reset();
  };

  return (
    <> <Helmet>
      <title>
        Forgot Password?
      </title>
    </Helmet>
      <OverlayLoader visible={state.loader} />
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-2-strong">
              <div className="card-body p-5">
                <h3 className="mb-5">Forgot Password?</h3>
                <form onSubmit={handleSubmit(onSubmitHandler)}>

                  <div className={optGen == true ? "d-none" : "d-block"}>
                    <UiInput
                      label="Username"
                      type="text"
                      required
                      name="username"
                      {...register("username")}
                      message={errors.username?.message}
                    />
                  </div>
                  {optGen == true &&
                    <>
                      <UiInput
                        label="OTP"
                        type="text"
                        required
                        name="otp"
                        {...register("otp")}
                        message={errors.otp?.message}
                      />
                      <UiInput
                        label="Password"
                        type="password"
                        required
                        name="password"
                        {...register("password")}
                        message={errors.password?.message}
                      />

                      <UiInput

                        required={true}
                        label="Confirm Password"
                        type="password"
                        name="password1"
                        message={errors.password1?.message}
                        {...register("password1")}
                      />

                    </>
                  }


                  <input type="hidden" value={optGen} name="otpgen" {...register("otpgen")} />
                  <input type="hidden" name="rid" {...register("rid")} />

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <UiButton className="btn btn-primary" type="submit" title="Continue" />
                    <Link to="/login" className="text-decoration-none text-primary">Go Back to Login</Link>

                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default ForgotPassword;
